import { useEffect, useRef } from 'react';
import { useMediaQuery, queryHelpers, Box } from '@leagueplatform/genesis-core';
import {
  ErrorState,
  ErrorStateProps,
} from '@leagueplatform/web-common-components';

type ErrorPageProps = Omit<ErrorStateProps, 'error'>;

export const ErrorPage = (props: ErrorPageProps) => {
  const isMobile = useMediaQuery(queryHelpers.down('tablet'));
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    containerRef.current?.focus();
  }, []);

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    <div
      ref={containerRef}
      tabIndex={-1}
      style={{ outline: '2px solid transparent' }}
    >
      <Box
        css={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: isMobile ? '0' : '$three',
        }}
      >
        <ErrorState error={null} {...props} />
      </Box>
    </div>
  );
};
